import { createContext, Dispatch } from 'react';
import type {
  WCmsPageView,
  WCmsHomepageView,
  WCmsFaqPageView,
  WCmsPhotoPageView,
  WCmsWeddingRegistryPageView,
  WCmsRsvpPageView,
  WCmsEventPageView,
  WCmsThingsToDoPageView,
  WCmsTravelPageView,
  WCmsWeddingPartyPageView,
} from '@zola/svc-web-api-ts-client';

import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';
import { EntitiesActions, PagesActions, EntitiesPropertyNames } from './actionTypes';

export type PagesStateType = WCmsPageView[];

export type ActivePageStateType =
  | WCmsPageView
  | WCmsHomepageView
  | WCmsFaqPageView
  | WCmsPhotoPageView
  | WCmsWeddingRegistryPageView
  | WCmsRsvpPageView
  | WCmsEventPageView
  | WCmsThingsToDoPageView
  | WCmsTravelPageView
  | WCmsWeddingPartyPageView
  | undefined;

export type EntitiesStateType = {
  [k: string]: GenericEntityType[];
};

export type MainStateType = {
  activePage: ActivePageStateType;
  entities: EntitiesStateType;
  pages: PagesStateType;
};

export const initialState = {
  activePage: undefined,
  pages: [],
  entities: {
    [EntitiesPropertyNames.homepage_sections]: [],
    [EntitiesPropertyNames.homepage_video]: [],
    [EntitiesPropertyNames.faqs]: [],
    [EntitiesPropertyNames.photos]: [],
    [EntitiesPropertyNames.videos]: [],
    [EntitiesPropertyNames.wedding_registries]: [],
    [EntitiesPropertyNames.events]: [],
    [EntitiesPropertyNames.pois]: [],
    [EntitiesPropertyNames.travel]: [],
    [EntitiesPropertyNames.wedding_party_members]: [],
  },
};

type EditWebsiteContextType = {
  state: MainStateType;
  dispatch: Dispatch<EntitiesActions | PagesActions>;
};

export const EditWebsiteContext = createContext<EditWebsiteContextType>({
  state: initialState,
  dispatch: () => null,
});
